module.exports = __webpack_public_path__ + "static/media/ticket.b5294d99.png";